module.exports = __webpack_public_path__ + "img/retkisatama_original.92e2d19b.jpg";